/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect,useState } from "react";
import Tweet from "../home/Tweet";

const Profile_Posts_Any = (props) => {
    const [posts,setPosts] = useState([]);

    useEffect(() => {
        fetch(`/userposts?q=${props.id}`)
        .then(res => res.json())
        .then(data => {
            setPosts(data);
        })
        .catch(error => console.log(error));
    },[]);
    return(
        <div className="main_content_section home_tweets_section">
            {
                posts.map(post => {
                    return(
                        <Tweet key={post.id} content={post.content} date={post.post_date} user_id={post.user_id} />
                    )
                })
            }
        </div>
    )
}

export default Profile_Posts_Any;